document.documentElement.classList.remove('no-js');

const menuToggle = document.querySelector('[data-menu-toggle]');
const siteNav = document.querySelector('[data-site-nav]');

const closeMenu = () => {
  if (!menuToggle || !siteNav) return;
  menuToggle.setAttribute('aria-expanded', 'false');
  siteNav.classList.remove('is-open');
  document.body.classList.remove('menu-open');
};

if (menuToggle && siteNav) {
  menuToggle.addEventListener('click', () => {
    const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!isOpen));
    siteNav.classList.toggle('is-open', !isOpen);
    document.body.classList.toggle('menu-open', !isOpen);
  });
  siteNav.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMenu();
      menuToggle.focus();
    }
  });
}

document.querySelectorAll('[data-product-form]').forEach((container) => {
  const productJson = container.querySelector('[data-product-json]');
  const variantInput = container.querySelector('[data-variant-id]');
  const price = container.querySelector('[data-product-price]');
  const addButton = container.querySelector('[data-add-button]');
  const addLabel = container.querySelector('[data-add-label]');
  const error = container.querySelector('[data-product-error]');
  const dispatch = container.querySelector('[data-dispatch-status]');
  const summaryPrice = container.querySelector('[data-summary-price]');
  const summaryDispatch = container.querySelector('[data-summary-dispatch]');
  const fieldsets = Array.from(container.querySelectorAll('[data-option-index]'));
  const isCommission = container.dataset.commissionBuilder === 'true';

  if (!productJson || !variantInput || !addButton || !addLabel) return;

  let variants = [];
  try {
    variants = JSON.parse(productJson.textContent);
  } catch (parseError) {
    addButton.disabled = true;
    if (error) {
      error.hidden = false;
      error.textContent = container.dataset.unavailableLabel;
    }
    return;
  }

  const formatPrice = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'AUD',
  }).format(cents / 100);

  const selections = () => fieldsets.map((fieldset) => fieldset.querySelector('input:checked')?.value);

  const variantFor = (selectedOptions) => variants.find((variant) => (
    variant.options.every((option, index) => option === selectedOptions[index])
  ));

  const optionCanSell = (optionIndex, optionValue, currentSelections) => variants.some((variant) => {
    if (!variant.available || variant.options[optionIndex] !== optionValue) return false;
    return variant.options.every((variantOption, index) => (
      index === optionIndex || !currentSelections[index] || variantOption === currentSelections[index]
    ));
  });

  const updateOptionStates = (currentSelections) => {
    fieldsets.forEach((fieldset, optionIndex) => {
      fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
        const canSell = optionCanSell(optionIndex, input.value, currentSelections);
        input.disabled = !canSell && !input.checked;
        const label = fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (!label) return;
        label.classList.toggle('is-unavailable', !canSell);
        label.setAttribute('aria-disabled', String(!canSell));
        const state = label.querySelector('[data-option-state]');
        if (state) state.textContent = canSell ? '' : container.dataset.unavailableLabel;
      });
    });
  };

  const updateSummary = (currentSelections, variant) => {
    currentSelections.forEach((value, index) => {
      const target = container.querySelector(`[data-summary-option="${index}"]`);
      if (target) target.textContent = value || '—';
    });
    if (summaryPrice && variant) summaryPrice.textContent = formatPrice(variant.price);
    if (summaryDispatch && dispatch) summaryDispatch.textContent = dispatch.textContent;
  };

  const updateVariant = () => {
    const currentSelections = selections();
    const variant = fieldsets.length === 0
      ? variants.find((candidate) => String(candidate.id) === String(variantInput.value)) || variants.find((candidate) => candidate.available) || variants[0]
      : variantFor(currentSelections);
    updateOptionStates(currentSelections);
    updateSummary(currentSelections, variant);

    if (!variant) {
      addButton.disabled = true;
      addLabel.textContent = container.dataset.unavailableLabel;
      variantInput.value = '';
      if (error) {
        error.hidden = false;
        error.textContent = container.dataset.unavailableLabel;
      }
      return;
    }

    variantInput.value = variant.id;
    if (price) price.textContent = formatPrice(variant.price);
    addButton.disabled = !variant.available;
    addLabel.textContent = variant.available ? container.dataset.availableLabel : container.dataset.soldOutLabel;
    if (error) error.hidden = true;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    if (variant.featured_image?.src) {
      const primaryImage = document.querySelector('.product-media--primary img');
      if (primaryImage && primaryImage.src !== variant.featured_image.src) primaryImage.src = variant.featured_image.src;
    }
  };

  fieldsets.forEach((fieldset) => {
    fieldset.querySelectorAll('input[type="radio"]').forEach((input) => input.addEventListener('change', updateVariant));
  });

  const form = container.querySelector('form');
  if (form) {
    addButton.addEventListener('click', (event) => {
      event.preventDefault();
      form.requestSubmit();
    });
    form.addEventListener('submit', (event) => {
      if (!variantInput.value) {
        const fallbackVariant = fieldsets.length === 0
          ? variants.find((candidate) => candidate.available) || variants[0]
          : variantFor(selections());
        if (fallbackVariant) variantInput.value = fallbackVariant.id;
      }
      if (!variantInput.value || addButton.disabled) {
        event.preventDefault();
        if (error) {
          error.hidden = false;
          error.textContent = isCommission ? container.dataset.selectLabel : container.dataset.unavailableLabel;
          error.focus?.();
        }
      }
    });
  }

  updateVariant();
});
